import React from "react";
import styles from "./styles.module.css";

type Props = {
  children: React.JSX.Element[] | React.JSX.Element;
};

const ActionBanner = ({ children }: Props) => {
  return <div className={styles.banner}>{children}</div>;
};

export default ActionBanner;
